var map = {
	"./banner-02.jpg": 6361,
	"./course-01.jpg": 3235,
	"./course-01.png": 8388,
	"./course-02.jpg": 5834,
	"./course-02.png": 6273,
	"./course-03.jpg": 3932,
	"./course-03.png": 8983,
	"./course-04.jpg": 2205,
	"./course-04.png": 2054,
	"./course-05.jpg": 9823,
	"./course-05.png": 5298,
	"./course-06.jpg": 4571,
	"./course-06.png": 8562,
	"./course-07.jpg": 8520,
	"./course-08.jpg": 3335,
	"./course-09.jpg": 7788,
	"./course-10.jpg": 9367,
	"./course-11.jpg": 1448,
	"./course-12.jpg": 4944,
	"./course-13.jpg": 8512,
	"./course-14.jpg": 1207,
	"./course-15.jpg": 6125,
	"./course-16.jpg": 2044,
	"./course-17.jpg": 2422,
	"./course-detail-01.png": 9465,
	"./course-detail-02.png": 6546,
	"./course-detail-03.png": 8597,
	"./course-koreanlm.png": 1279,
	"./course-llama.png": 8850,
	"./course-pretrain.jpg": 2096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2876;